import React from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {ChoosenFilteredInput, inputTitlesBottomSheet} from '../../../constants';
import useGetInputLists from '../../../../../../services/hookService/getInputLists/useGetInputLists';
import CardInputGroup from '../../../../../../components/mazraeKit/CardInputGroup';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from '../../../../../../store/redux';
import {addRegisterAdvertisement} from '../../../../../../store/redux/advertisementRegisteration';
import DotsLoading from '../../../../../../components/dotsLoading';
import {ISrs_type} from '../../../types';

interface IInputListBottomsheet {
  srs_type?: ISrs_type;
  openInputListBottomSheet: boolean;
  setOpenInputListBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
}

function InputListBottomsheet({
  srs_type,
  openInputListBottomSheet,
  setOpenInputListBottomSheet,
}: IInputListBottomsheet) {
  const state = useSelector(
    (state: RootState) => state?.advertisementRegisteration,
  );

  const {data: inputlists, isLoading} = useGetInputLists({
    input_group__guid: state?.input_group?.guid,
  });

  const dispatch = useDispatch();

  return (
    <BottomSheet
      onDismiss={() => setOpenInputListBottomSheet(false)}
      open={openInputListBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col gap-3 px-3 pb-3">
        {srs_type &&
          state?.input_group?.code &&
          srs_type?.type !== 'rent' &&
          srs_type?.type !== 'service' &&
          inputTitlesBottomSheet[srs_type?.type + state?.input_group?.code]()}
        {srs_type &&
          state?.input_group?.code &&
          srs_type?.type === 'service' &&
          inputTitlesBottomSheet[
            srs_type.type +
              state?.input_group?.code +
              state?.serviceBottomSheetData
          ]()}
        {srs_type &&
          state?.input_group?.code &&
          srs_type.type === 'rent' &&
          inputTitlesBottomSheet[
            srs_type.type +
              state?.input_group?.code +
              state?.rentBottomSheetData
          ]()}

        <div className="grid grid-cols-4 w-full">
          {isLoading ? (
            <div className="absolute top-1/2 left-1/2 mt-2 -translate-x-2/4">
              <DotsLoading />
            </div>
          ) : (
            inputlists
              ?.filter(item => {
                return srs_type?.type && state?.input_group
                  ? !(
                      ChoosenFilteredInput[srs_type?.type][
                        state?.input_group?.code
                      ] || undefined
                    )?.includes(item.code.toString())
                  : item;
              })
              ?.map(item => {
                return (
                  <div className="flex justify-center w-full" key={item.guid}>
                    <CardInputGroup
                      isBoled={false}
                      title={item.title}
                      image={item.image}
                      guid={item.guid}
                      clickHandler={() => {
                        dispatch(
                          addRegisterAdvertisement({
                            input: {
                              title: item.title,
                              guid: item.guid,
                              code: item.code,
                            },
                          }),
                        );
                        setOpenInputListBottomSheet(false);
                      }}
                    />
                  </div>
                );
              })
          )}
        </div>
      </div>
    </BottomSheet>
  );
}

export default React.memo(InputListBottomsheet);
